const SupplierType = {
  SUPPLIER_LIST: 'SUPPLIER_LIST',
  ADD_SUPPLIER: 'ADD_SUPPLIER',
  DELETE_SUPPLIER: 'DELETE_SUPPLIER',
  UPDATE_SUPPLIER: 'UPDATE_SUPPLIER',
  SUPPLIER_COMPONENT_LIST: 'SUPPLIER_COMPONENT_LIST',
  ONE_SUPPLIER_COMPONENT: 'ONE_sUPPLIER_COMPONENT',
  ADD_SUPPLIER_COMPONENT: 'ADD_SUPPLIER_COMPONENT',
  DELETE_SUPPLIER_COMPONENET: 'DELETE_SUPPLIER_COMPONENET',
  UPDATE_COMPONENET_SUPPLIER: 'UPDATE_COMPONENT_SUPPLIER',
  DELETE_USER: 'DELETE_USER',
  ADD_USER: 'ADD_USER',
  GET_USER: 'GET_USER',
  EDIT_USER: 'EDIT_USER',
  EDIT_USER_STATUS: 'EDIT_USER_STATUS',
  DELETE_MULTI_USER: 'DELETE_MULTI_USER',
  SET_BRAND_AND_CATEGORY_ASSIGMENT: 'SET_BRAND_AND_CATEGORY_ASSIGMENT',
  ALL_SUPPLIER_DOCUMENT_LIST: 'ALL_SUPPLIER_DOCUMENT_LIST',
  DOCUMENT_LIST: 'dOCUMENTLIST',
  ADD_DOCUMENT: 'ADD_DOCUMENT',
  REARRANGING_DOCUMENTS: 'REARRANGING_DOCUMENTS',
  UPDATE_DOCUMENT: 'UPDATE_DOCUMENT',
  DELTE_DOCUMENT: 'DELETE_DOCUMENT',
  DELETE_MULTI_DOCUMENTS: 'DELETE_MULTI_DOCUMENTS',
  DUE_DATES_LIST: 'DUE_DATES_LIST',
  FACTORY_CLEAR: 'FACTORY_CLEAR',
  DELETE_DUE_DATE: 'DELETE_DUE_DATE',
  ADD_AUTO_DUE_DATES_LIST: 'ADD_AUTO_DUE_DATES_LIST',
  BRANDS: 'BRANDS',
  CATEGORY1: 'CATEGORY1',
  CATEGORY2: 'CATEGORY2',
  APPROVE_REJECT_DOCUMENT: 'APPROVE_REJECT_DOCUMENT',
  CLEAR: 'CLEAR',
  CLEAR_USER_REDUCER: 'CLEAR_USER_REDUCER',
  GET_PENDING_TYPE: 'GET_PENDING_TYPE',
  GET_TIER1: 'GET_TIER1',
  GET_TIER2_ABOVE: 'GET_TIER2_ABOVE',
  GET_ALL_TIER: 'GET_ALL_TIER',
  GET_FACTORY_SUPPLIERS: 'GET_FACTORY_SUPPLIERS',
  GET_PRODUCT_SUPPLIER: 'GET_PRODUCT_SUPPLIER',
  SUPPLIER_TAGS: 'SUPPLIER_TAGS',
  GET_SUPPLIER_TEMPLATE_BY_ID: 'GET_SUPPLIER_TEMPLATE_BY_ID',
  GET_SUPPLIER_TEMPLATE: 'GET_SUPPLIER_TEMPLATE',
  UNMOUNT_LIBRARY: 'UNMOUNT_LIBRARY',
  GET_DOCUMENT_TEMPLATE: 'GET_DOCUMENT_TEMPLATE',
  GET_ALL_TEMPLATE: 'GET_ALL_TEMPLATE',
  CLEAR_DATA: 'CLEAR_DATA',
  SOURCE_TEMPLATE: 'SOURCE_TEMPLATE',
  LIBRARY_PAGES: 'LIBRARY_PAGES',
  GET_PARTNER_MODULE_LIST: 'GET_PARTNER_MODULE_LIST',
  GET_PARTNER_MODULE_PAGE_CONTROL_LIST: 'GET_PARTNER_MODULE_PAGE_CONTROL_LIST',
  SUPPLIER_PAGE_LIST: 'SUPPLIER_PAGE_LIST',
  GET_PARTNER_MODULE_DEPENDENT_CONTROL_LIST: 'GET_PARTNER_MODULE_DEPENDENT_CONTROL_LIST',
  FACTORIES_TAGS: 'FACTORIES_TAGS',
  GET_SUPPTIER2: 'GET_SUPPTIER2',
  GET_SUPPTIER3: 'GET_SUPPTIER3',
  GET_SUPPTIER4: 'GET_SUPPTIER4',
  GET_SUPPTIER1: 'GET_SUPPTIER1',
  GET_PARTNER_PAGE_CALCULATION_CONTROL_LIST: 'GET_PARTNER_PAGE_CALCULATION_CONTROL_LIST',
  CALCULATION_LIBRARY_PAGES: 'CALCULATION_LIBRARY_PAGES',
  GET_SUPPLIER_TEMPLATE_CALCULATION_PAGE: 'GET_SUPPLIER_TEMPLATE_CALCULATION_PAGE',
  SUPPLIER_COMPONENT_FACTORY_LIST: 'SUPPLIER_COMPONENT_FACTORY_LIST',
  CLEAR_SINGLE_SUPPLIER: 'CLEAR_SINGLE_SUPPLIER',
  GET_SUPPTIERONE: 'GET_SUPPTIERONE',
  GET_SUPPTIERTWO: 'GET_SUPPTIERTWO',
  GET_SUPPTIERTHREE: 'GET_SUPPTIERTHREE',
  GET_SUPPTIERFOUR: 'GET_SUPPTIERFOUR',
};

export default SupplierType;
